import { Picker } from "features/render";

/** Picker modes that display a center-positioned coachmark. */
export const PICKERS = [
    Picker.OutlineLaser,
    Picker.Coordinates,
    Picker.PointLine,
    Picker.Dimension,
    Picker.ObjectMeasurement,
    Picker.SectionPlane,
    Picker.Pins,
];
